import React from "react"
import Layout from "../components/layout"
import Members from "../components/memberships"
import Application from "../components/application"
import memberPhoto from "../images/member-mobile.jpg"
import landverndLogo from "../images/landvernd-cropped.png";


class JoinPage extends React.Component {

    render() {
      return(
      <Layout>

            <a href="https://teespring.com/stores/iceberg-licking-society" target="_blank" rel="noopener noreferrer" className="ils-btn ils-btn--fixed-left">Shop</a>
            <a href="/" className="ils-btn ils-btn--fixed">Home</a>
            <div className="landvernd-container">
              <p className="small-heading">Official Partner:</p>
              <a href="https://landvernd.is/en-landvernd-icelandic-environment-association/" target="_blank" rel="noopener noreferrer"><img src={landverndLogo} alt="Landvernd" id="landvernd-logo" /></a>
            </div>

            <section className="mobile-image">
              <img src={memberPhoto} alt="Member" />
            </section>

            <Members />

            <section>
              <h3 className="section-heading">Becoming a member</h3>
              <p className="text">ILS members are responsible for a distinguished collection of famous firsts: Iceberg A-22 first lick, A-38 first lick & 
              Iceberg B-15 first lick. Through our work in research, education, public service, conservation, and exploration, our ambition is to raise 
              awareness of the melt and to preserve the instinct to lick. </p>
            </section>
        
            <section>
              <h3 className="section-heading">Your Application</h3>
              <p className="text desktop-text">It's simple to join the ILS movement. Take a photo of yourself licking ice of any kind and upload it here on our website. 
              This will generate your free and unique digital membership card.
              </p>
              <p className="text mobile-text">It's simple to join the ILS movement. Take a photo of yourself licking ice of any kind and upload it on our website. For now,
              you'll have to visit our website on a desktop computer using Chrome or Firefox to use the form.</p>
            </section>


            <Application />
        
        </Layout>
      )
      
    }   
}
  
  export default JoinPage